/* global axios */
/**
 * The account's channels, read from CHATWOOT (P-10.26): which of the seven channel words its
 * inboxes are. The same call and the same reasons as `api/templates.js` `senders`: these are
 * Chatwoot's own routes, and the Waslo tree holds no store dependency.
 *
 * A read that fails is `[]`, which every screen reads as "not known": the composer then offers
 * all seven channels rather than none.
 */
import { channelsOfInboxes } from '../helpers/task-channels.js';

export const accountChannels = async (accountId, signal) => {
  try {
    const { data } = await axios.get(`/api/v1/accounts/${accountId}/inboxes`, {
      signal,
    });
    return channelsOfInboxes(data?.payload);
  } catch {
    return [];
  }
};

export default accountChannels;
